import React, { useState } from 'react';
import { CodeManagementPage } from './CodeManagementPage';
import { NhrplOverridesPage } from './NhrplOverridesPage';

type Tab = 'codes' | 'overrides';

export function NhrplManagementPage() {
  const [tab, setTab] = useState<Tab>('codes');

  return (
    <div>
      <div className="border-b border-gray-200 bg-white px-6 pt-4">
        <h1 className="text-xl font-semibold mb-3">NHRPL Code Management</h1>
        <div className="flex gap-1">
          <TabButton active={tab === 'codes'} onClick={() => setTab('codes')}>
            Codes
          </TabButton>
          <TabButton active={tab === 'overrides'} onClick={() => setTab('overrides')}>
            Price overrides
          </TabButton>
        </div>
      </div>
      {tab === 'codes' ? (
        <CodeManagementPage codeType="nhrpl" title="" showTariff showCategory />
      ) : (
        <NhrplOverridesPage />
      )}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={
        'px-4 py-2 text-sm font-medium border-b-2 -mb-px ' +
        (active
          ? 'border-blue-600 text-blue-700'
          : 'border-transparent text-gray-600 hover:text-gray-900')
      }
    >
      {children}
    </button>
  );
}
